import { Component, HostListener, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AppConsts } from '@shared/AppConsts';
import { DashboardViewAsService } from '@app/main/merchant-dashboard/dashboard-view-as.service';

@Component({
    selector: 'environment-badge',
    templateUrl: './environment-badge.component.html',
    styleUrls: ['./environment-badge.component.less']
})
export class EnvironmentBadgeComponent implements OnInit {
    envName: string = '';
    /** TEST ONLY: dashboard tenants to view as (empty unless the API allows it). */
    testTenants: { tenantId: number; tenancyName: string; name: string; sourceTenantId: number }[] = [];

    constructor(private _http: HttpClient, public viewAs: DashboardViewAsService) {}

    ngOnInit(): void {
        this.envName = (environment?.envName ?? '').trim();
        if (this.shouldShow) {
            this._http.get<any>(`${AppConsts.remoteServiceBaseUrl}/api/services/app/MerchantDashboard/GetTestTenants`).subscribe(
                (r) => (this.testTenants = (r && r.result) || []),
                () => (this.testTenants = [])
            );
        }
    }

    /** TEST ONLY: the tenant menu under the badge */
    menuOpen = false;

    toggleMenu(e: MouseEvent): void {
        e.stopPropagation();
        if (this.testTenants.length) {
            this.menuOpen = !this.menuOpen;
        }
    }

    pick(tenantId: number | null): void {
        this.menuOpen = false;
        this.viewAs.set(tenantId || null);
    }

    @HostListener('document:click')
    @HostListener('document:keydown.escape')
    closeMenu(): void {
        this.menuOpen = false;
    }

    onViewAs(value: string): void {
        this.viewAs.set(Number(value) || null);
    }

    get shouldShow(): boolean {
        return !!this.envName && this.envName.toLowerCase() !== 'production';
    }

    get badgeClass(): string {
        const env = this.envName.toLowerCase();

        if (env.includes('dev') || env.includes('local')) {
            return 'env-dev';
        }

        if (env.includes('uat') || env.includes('staging')) {
            return 'env-uat';
        }

        if (env.includes('test')) {
            return 'env-test';
        }

        return 'env-default';
    }
}